















import Vue from "vue";
import { VCol } from "vuetify/lib";
import { defineComponent } from "@vue/composition-api";
import { Dictionary } from "@/types";
import { castComponent } from "@/lib/helpers";
import Draggable from "@/components/Draggable";

Vue.component("Draggable", castComponent(Draggable));
Vue.component("VCol", castComponent(VCol));

export default defineComponent({
  name: "BaseGrid",
  props: {
    list: { type: Array as () => any[], required: true },
    flexClass: {
      type: [Object as () => Dictionary<boolean>, String],
      required: false,
      default: () => ({
        "col-6": true,
        "col-md-4": true,
        "col-lg-3": true,
        "col-xl-2": true,
      }),
    },
    itemKey: { type: String, required: true },
    draggable: { type: Boolean, default: false },
    dragDisabled: { type: Boolean, default: true },
  },
});
